export function formatCurrency(value, currency = 'USD') {
  const credit = value > 0;
  value = Math.abs(value) / 100.0;

  if (credit) {
    return <span className={''}>${value.toFixed(2)}</span>;
  } else {
    return <span className={'text-red-600'}>${value.toFixed(2)} (refund)</span>;
  }
}

export const dollarsToUsdFormat = (value, options) => {
  const defaultOptions = { style: 'currency', currency: 'USD', maximumFractionDigits: 2 };
  return new Intl.NumberFormat('en-US', { ...defaultOptions, ...options }).format(value);
};

export const centsToUsdFormat = (value, options) => dollarsToUsdFormat(value / 100, options);

export const wageDollarsFormat = (value, interval) => {
  if (interval === 'per hour' && (value * 100) % 100 !== 0) {
    return dollarsToUsdFormat(value);
  }

  return dollarsToUsdFormat(value, { minimumFractionDigits: 0 });
};
